import React from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';

const TagWrapper = styled(Tag)`
  margin-right: 3px;
  background: #eaeaea;
  color: #30384c;
`;

interface TagRenderProps {
  label: string;
  value: string;
  closable: boolean | undefined;
  onClose: () => void;
  [x: string]: any;
}

const TagRender = (props: TagRenderProps) => {
  const { label, value } = props;

  return (
    <TagWrapper color={value} {...props}>
      {label}
    </TagWrapper>
  );
};
export default TagRender;
